// Mirrors RoleModuleAccessDto on the backend.
export class RoleModuleAccessModel {
  public RoleId: number = 0
  public ModuleId: number = 0
  public Allowed: boolean = false
  public ModuleNoAccessVisibilityType: number = 0
}
